 import {defaultOperatorIN,defaultOperatorID,defaultOperatorPH,defaultOperatorSG,defaultOperatorMY,defaultOperatorAE} from 'modules/ui/constants'

 export const IsDefaultOperator = () => {
     const oprator = window.location.pathname.split("/")[1].toUpperCase();
     const oppArr = [defaultOperatorIN,defaultOperatorID,defaultOperatorPH,defaultOperatorSG,defaultOperatorMY,defaultOperatorAE];
     const result = oppArr.includes(oprator);
     return result
 }